import LoaderButton from 'components/LoaderButton'
import PropTypes from 'prop-types'
import React from 'react'
import { Alert, Button, Form } from 'react-bootstrap'
import Modal from 'react-bootstrap/Modal'

function ScheduleModal({
  show,
  onHide,
  slide,
  onChangeFrom,
  onChangeUntil,
  loading,
  onSubmit,
  errorMessage = '',
}) {
  const handleSubmit = async e => {
    e.preventDefault()
    onSubmit()
  }

  return (
    <Modal show={show} onHide={onHide}>
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>Schedule</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>Display from</Form.Label>
            <Form.Control
              isInvalid={!!errorMessage}
              name='display_from'
              type='datetime-local'
              value={slide?.display_from ?? ''}
              onChange={onChangeFrom}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Display until</Form.Label>
            <Form.Control
              isInvalid={!!errorMessage}
              name='display_until'
              type='datetime-local'
              value={slide?.display_until ?? ''}
              onChange={onChangeUntil}
            />
          </Form.Group>

          {errorMessage && <Alert variant='danger'>{errorMessage}</Alert>}
        </Modal.Body>
        <Modal.Footer>
          <Button disabled={loading} variant='secondary' onClick={onHide}>
            Cancel
          </Button>
          <LoaderButton
            loading={loading}
            label='Submit'
            variant='success'
            type='submit'
          />
        </Modal.Footer>
      </Form>
    </Modal>
  )
}

ScheduleModal.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
  slide: PropTypes.object,
  onChangeFrom: PropTypes.func,
  onChangeUntil: PropTypes.func,
  loading: PropTypes.bool,
  onSubmit: PropTypes.func,
  errorMessage: PropTypes.string,
}

ScheduleModal.defaultProps = {
  show: false,
  loading: false,
  errorMessage: '',
}

export default ScheduleModal
